import { VFC } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import { GOOGLE_MAPS_API_KEY } from 'consts/common';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { ViewMeters } from '@enmon/commons/lib/enmon';
import { MapContent } from './map/Content';
import { StyledMapWrapper } from './map/StyledWrapper';
import { useEnmonMeters } from '../../../hooks/api/enmon-tools/meters/useFind';

export const MeterListMap: VFC = () => {
  const { data: { result: meters } = {}, isLoading } = useEnmonMeters({}, {}, ViewMeters.Map);

  if (isLoading) return <LoadingSpinner />;
  if (!meters) return null;

  return (
    <Wrapper apiKey={GOOGLE_MAPS_API_KEY}>
      <StyledMapWrapper>
        <MapContent meters={meters} />
      </StyledMapWrapper>
    </Wrapper>
  );
};
